import { render } from "./FileReferencesTable.vue?vue&type=template&id=2395ae38&scoped=true"
import script from "./FileReferencesTable.vue?vue&type=script&lang=js"
export * from "./FileReferencesTable.vue?vue&type=script&lang=js"

import "./FileReferencesTable.vue?vue&type=style&index=0&id=2395ae38&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2395ae38"]])

export default __exports__